






















import { Component, Emit, Prop, Vue, Watch } from "vue-property-decorator";
import moment from "moment";
@Component({
  components: {},
})
export default class MyColorPicker extends Vue {
  @Prop({ default: "" }) value: string;

  show = false;

  get color() {
    return this.value;
  }

  set color(val) {
    console.log("sdfdsfsdf: ", val);
      this.$emit("input", val);
    // this.lodash.debounce(() => {
    //   this.$emit("input", val);
    // }, 300);
  }

}
